export default __webpack_public_path__ + "static/media/4.9b53f9db.png";